import React, { useContext } from "react";
import { SettingsContext } from "../../settingsContext";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { BNBox, BNButton } from "@bn-monorepo/js-packages";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router";

interface Props {
  list?: Array<{
    url: string;
    name: string;
    isInternal: boolean;
  }>;
  hide?: boolean;
}

const Breadcrumbs: React.FC<Props> = (props) => {
  const { resolveUrl } = useContext(SettingsContext);
  const theme = useTheme();
  const { list, hide } = props;
  if (list) {
    return (
      <>
        {!hide && (
          <BNBox
            sx={{
              display: "flex",
              justifyContent: "center",
              margin: 2,
              marginBottom: 1,
            }}
          >
            <BNBox
              component={"nav"}
              aria-label="breadcrumbs"
              sx={{
                width: "120rem",
                display: "flex",
                flexWrap: "wrap",
                mx: 1,
                [theme.breakpoints.down("md")]: {
                  maxWidth: "60rem",
                },
              }}
            >
              {list.map((menuItem, index) =>
                index < list.length - 1 ? (
                  <React.Fragment key={`breadcrumb-${index}`}>
                    <BNButton
                      variant="text"
                      textDecoration={true}
                      sx={{ p: 0, minWidth: 0, fontSize: { xs: "1.4rem" } }}
                      href={!menuItem.isInternal ? resolveUrl(menuItem.url) : undefined}
                      LinkComponent={menuItem.isInternal ? Link : undefined}
                      to={menuItem.isInternal ? resolveUrl(menuItem.url) : undefined}
                    >
                      {menuItem.name}
                    </BNButton>
                    <BNBox key={`breadcrumb-separator-${index}`} component="span" sx={{ height: "2.2rem" }}>
                      <KeyboardArrowRightIcon
                        sx={{
                          fontSize: 16,
                          color: "secondary.main",
                          marginTop: "0.4rem",
                        }}
                      />
                    </BNBox>
                  </React.Fragment>
                ) : (
                  <BNButton
                    key={`breadcrumb-last`}
                    variant="text"
                    textDecoration={false}
                    sx={{
                      p: 0,
                      minWidth: 0,
                      fontSize: { xs: "1.4rem" },
                      cursor: "default",
                    }}
                    component={"span"}
                    aria-disabled="true"
                    disableRipple
                    tabIndex={-1}
                  >
                    {menuItem.name}
                  </BNButton>
                ),
              )}
            </BNBox>
          </BNBox>
        )}
      </>
    );
  }
  return null;
};

export default Breadcrumbs;
